import $ from 'jquery'
import Location from './location'
import UserDetails from './user_details'

export default class User {
  constructor(attribs = {}) {
    this._attribs = attribs
    this._userName = attribs.message || attribs.username
    this._fullName = attribs.firstName || attribs.full_name || this._userName
    this.id = attribs.id || attribs.user_id || null
  }

  toJSON() {
    return Object.assign(this._attribs)
  }

  getUserName() {
    return this._userName
  }
  getFullName() {
    return this._fullName
  }

  getProfileImageUrl() {
    return this._attribs.profileImageUrl
  }

  getEmail() {
    return this._attribs.email
  }

  getFirstAndLastName() {
    const firstName = this._attribs.firstName
    const lastName = this._attribs.lastName
    if (firstName && lastName) {
      return [firstName, lastName].join(' ')
    }
    return this.getFullName()
  }

  getDetails() {
    return $.when(Location.getCurrent()).then(location => {
      return this.getDetailsByLocation(location)
    })
  }

  getDetailsByLocation(location) {
    const defer = $.Deferred()
    const url = location.addUrlPrefix('/WAS/profile')
    $.getJSON(url)
      .done(function(data) {
        if (data.success === false) {
          if (!data.reason) {
            data.reason = 'Server error'
          }
          return defer.reject(data)
        } else {
          return defer.resolve(new UserDetails(data))
        }
      })
      .fail(function(response) {
        let data
        try {
          data = JSON.parse(response.responseText)
        } catch (error) {
          data = {
            success: false,
            code: response.status,
            reason: response.statusText
          }
        }

        if (!data.reason) {
          data.reason = 'Server error'
        }
        return defer.reject(data)
      })

    return defer.promise()
  }

  get isCarpoolDriver() {
    return !!this._attribs.isCarpoolDriver
  }

  get isCarpoolRider() {
    return !!this._attribs.isCarpoolRider
  }
}
